import {Pokedex} from '../Data/pokedex'
import {Learnsets} from '../Data/learnsets'

const getBaseFormSafeId = (pokemon) => {
    if (!pokemon?.baseSpecies) return null;
    return pokemon.baseSpecies.toLowerCase().replace(/[^a-z0-9]/g, '');
};

const getEvolutionChain = (safeId) => {
    const chain = [];
    const visited = new Set();

    let currentId = safeId;
    const startPokemon = Pokedex[safeId];

    // Если это форма — добавляем форму и идём от базовой
    const baseFormId = getBaseFormSafeId(startPokemon);
    if (baseFormId && baseFormId !== safeId) {
        chain.push(safeId);
        visited.add(safeId);
        currentId = baseFormId;
    }

    // Идём по цепочке prevo
    while (currentId && !visited.has(currentId)) {
        chain.push(currentId);
        visited.add(currentId);

        const current = Pokedex[currentId];
        if (!current?.prevo) break;

        // ВАЖНО: prevo может быть в любом регистре, нормализуем
        currentId = current.prevo.toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    return chain;
};

const getOwnLearnset = (safeId) => {
    const pokemon = Pokedex[safeId];

    const own = Learnsets[safeId];
    if (own?.learnset && Object.keys(own.learnset).length > 0) {
        return Object.keys(own.learnset);
    }

    // Fallback на базовую форму
    const baseId = getBaseFormSafeId(pokemon);
    if (baseId && baseId !== safeId) {
        const base = Learnsets[baseId];
        if (base?.learnset) {
            return Object.keys(base.learnset);
        }
    }

    return [];
};

const getInheritedLearnset = (safeId) => {
    const chain = getEvolutionChain(safeId);
    const allMoves = new Set();

    console.log('Chain for', safeId, ':', chain);
    chain.forEach(evoId => {
        console.log(evoId, '→ learnset keys:', Object.keys(Learnsets[evoId]?.learnset || {}));
    });
    chain.forEach(evoId => {
        // Пробуем оба варианта ключа: safeId и оригинальный из Pokedex
        const pokemon = Pokedex[evoId];
        const originalName = pokemon?.name?.toLowerCase().replace(/[^a-z0-9]/g, '');

        const ids = new Set([evoId, originalName].filter(Boolean));

        ids.forEach(tryId => {
            const learnsetData = Learnsets[tryId];
            if (learnsetData?.learnset) {
                Object.keys(learnsetData.learnset).forEach(move => allMoves.add(move));
            }
        });
    });

    return Array.from(allMoves);
};

export const getPokemonCompleteData = (id) => {
    if (!id) return null;

    const safeId = id.toLowerCase().replace(/[^a-z0-9]/g, '');
    const pokemon = Pokedex[id] || Pokedex[safeId];
    if (!pokemon) return null;

    const moves = getInheritedLearnset(safeId);

    return {
        ...pokemon,
        id,
        learnset: moves
    };
};

export const getAllPokemonsList = () => {
    return Object.keys(Pokedex).map(id => ({
        id,
        ...Pokedex[id]
    }));
};